import { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[2px] bg-white/10 z-[1000]"
    >
      <motion.div
        className="h-full bg-white origin-left"
        style={{ scaleX }}
      />
    </motion.div>
  );
};

export default ScrollProgress;
